import nanostyled from 'nanostyled';

export const Container = nanostyled('div', {
  bg: 'bg-white',
  side: null,
  base:
    'border-box w-full h-full flex justify-center items-center pt-9 sm:pt-14',
});
